import { Listing } from './listing.type';

export const getListingImages = (
    listing: Listing
): {
    src: string;
    caption: string;
}[] => {
    const images: {
        src: string;
        caption: string;
    }[] = [];

    if (listing.image?.src) {
        images.push({
            src: listing.image?.src,
            caption: listing.image?.caption || ''
        });
    }

    if (listing.gallery) {
        const otherImages = listing.gallery.map(([caption, uri]) => {
            const src = uri.startsWith('/')
                ? 'https://lid.zoocdn.com/645/430' + uri
                : uri;
            return {
                caption: caption ?? '',
                src
            };
        });
        return [...images, ...otherImages];
    }

    listing.otherPropertyImages?.forEach((image) => {
        images.push({
            src: image?.large as string,
            caption: image?.caption as string
        });
    });

    return images;
};
